import ApplicationLogo from '@/Components/ApplicationLogo';
import {Link} from '@inertiajs/react';
import {cn} from "@/lib/utils"

export default function GuestLayout({children, className = ''}) {
    return (
        <div className={cn(`min-h-screen flex flex-col sm:justify-start items-center pt-6 sm:pt-28`, className)}>
            {children}
        </div>
    );
}
